import React from 'react';
import RolesTable from '../../components/rbac/RolesTable';

const RoleManagementTab: React.FC = () => {
  return <RolesTable />;
};

export default RoleManagementTab;
